import { useState } from "react";
import { COMPANY } from "@/data/products";
import { MessageCircle, X, Phone, Mail } from "lucide-react";

export default function WhatsAppFloat() {
  const [open, setOpen] = useState(false);

  const waMessage = encodeURIComponent(
    "Hello EELLEVEN MINING, I'm interested in your mineral products."
  );
  const wa1 = `https://wa.me/${COMPANY.whatsappPrimaryDigits}?text=${waMessage}`;
  const wa2 = `https://wa.me/${COMPANY.phoneZambiaDigits}?text=${waMessage}`;
  const wa3 = `https://wa.me/${COMPANY.phoneZambia2Digits}?text=${waMessage}`;

  return (
    <div
      data-testid="floating-contact"
      className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3"
    >
      {open && (
        <div
          data-testid="floating-contact-panel"
          className="w-72 bg-[var(--eel-surface)] border border-zinc-800 shadow-2xl"
        >
          <div className="px-4 py-3 border-b border-zinc-800 bg-zinc-900 flex items-center justify-between">
            <span className="label-eyebrow text-zinc-300">
              Talk to EELLEVEN
            </span>
            <button
              onClick={() => setOpen(false)}
              data-testid="floating-contact-close"
              aria-label="Close"
              className="text-zinc-400 hover:text-white"
            >
              <X size={16} />
            </button>
          </div>
          <div className="p-4 space-y-3 text-sm">
            <a
              href={wa1}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="floating-wa-ireland"
              className="flex items-center justify-between border border-zinc-800 px-3 py-3 hover:border-[var(--eel-copper)] transition-colors"
            >
              <span className="flex items-center gap-2">
                <MessageCircle size={16} className="text-green-500" />
                <span className="text-zinc-200">WhatsApp · IE</span>
              </span>
              <span className="text-zinc-400 text-xs">
                {COMPANY.whatsappPrimary}
              </span>
            </a>
            <a
              href={wa2}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="floating-wa-zambia"
              className="flex items-center justify-between border border-zinc-800 px-3 py-3 hover:border-[var(--eel-copper)] transition-colors"
            >
              <span className="flex items-center gap-2">
                <MessageCircle size={16} className="text-green-500" />
                <span className="text-zinc-200">WhatsApp · ZM</span>
              </span>
              <span className="text-zinc-400 text-xs">
                {COMPANY.phoneZambia}
              </span>
            </a>
            <a
              href={`tel:${COMPANY.phoneZambia}`}
              data-testid="floating-call"
              className="flex items-center justify-between border border-zinc-800 px-3 py-3 hover:border-[var(--eel-copper)] transition-colors"
            >
              <span className="flex items-center gap-2">
                <Phone size={16} className="copper-text" />
                <span className="text-zinc-200">Call Zambia</span>
              </span>
              <span className="text-zinc-400 text-xs">
                {COMPANY.phoneZambia}
              </span>
            </a>
            <a
              href={wa3}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="floating-wa-zambia-2"
              className="flex items-center justify-between border border-zinc-800 px-3 py-3 hover:border-[var(--eel-copper)] transition-colors"
            >
              <span className="flex items-center gap-2">
                <MessageCircle size={16} className="text-green-500" />
                <span className="text-zinc-200">WhatsApp · ZM 2</span>
              </span>
              <span className="text-zinc-400 text-xs">
                {COMPANY.phoneZambia2}
              </span>
            </a>
            <a
              href={`mailto:${COMPANY.email}`}
              data-testid="floating-email"
              className="flex items-center justify-between border border-zinc-800 px-3 py-3 hover:border-[var(--eel-copper)] transition-colors"
            >
              <span className="flex items-center gap-2">
                <Mail size={16} className="copper-text" />
                <span className="text-zinc-200">Email</span>
              </span>
              <span className="text-zinc-400 text-xs">{COMPANY.email}</span>
            </a>
          </div>
        </div>
      )}
      <button
        data-testid="floating-contact-toggle"
        onClick={() => setOpen((v) => !v)}
        aria-label="Contact us"
        className="w-14 h-14 rounded-full bg-green-500 hover:bg-green-600 text-black grid place-items-center shadow-2xl transition-transform hover:scale-105"
      >
        {open ? <X size={22} /> : <MessageCircle size={22} />}
      </button>
    </div>
  );
}
